export function formatToTwoDecimals(num: number): string {
    if(num)
        return num.toFixed(2);

    return '0.00';
}